export default "__VITE_ASSET__3crdH6H1__"